import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getPendingLedgerEsign,
  getSignedLedgerEsigns,
} from "services/eSignLedger";
import { path } from "utils/const";

import PendingActionSection from "./PendingActionSection";

// Fetches the customer's pending statement + whether any history exists, and
// renders the "Pending action" section. Used on both My Books and Home.
// pendingOnly (Home): render nothing unless there is an actual pending request —
// no "All caught up" empty state, and self-pad since there's no parent container.
export default function LedgerEsignPendingSection({ pendingOnly = false }) {
  const navigate = useNavigate();
  const { me } = useSelector((state) => state.app);
  const [pending, setPending] = useState(null);
  const [hasHistory, setHasHistory] = useState(false);

  useEffect(() => {
    if (!me?.customerId) return undefined;
    let alive = true;

    getPendingLedgerEsign(me.customerId)
      .then((res) => {
        if (!alive) return;
        const data = res?.responseData || res;
        // treat an empty object / null as "nothing pending"
        setPending(data && data.id ? data : null);
      })
      .catch(() => {});

    getSignedLedgerEsigns(me.customerId)
      .then((res) => {
        if (!alive) return;
        const list = res?.responseData || res || [];
        setHasHistory(Array.isArray(list) && list.length > 0);
      })
      .catch(() => {});

    return () => {
      alive = false;
    };
  }, [me?.customerId]);

  // On Home, only surface the card when something is actually pending.
  if (pendingOnly && !pending) return null;

  const section = (
    <PendingActionSection
      request={pending}
      hasHistory={pendingOnly ? false : hasHistory}
      onReview={() =>
        navigate(path.ledgerEsignViewer, {
          state: { request: pending, mode: "pending" },
        })
      }
      onViewSignedList={() => navigate(path.ledgerEsignSignedList)}
    />
  );

  // Home has no parent padding container, so wrap it; My Books already pads.
  return pendingOnly ? (
    <div style={{ padding: "1rem 1rem 0" }}>{section}</div>
  ) : (
    section
  );
}
